import React, {Component} from 'react';
import {connect} from 'react-redux';
import { browserHistory } from 'react-router';
import {PaginationHelpers as Page} from '../../../../../helpers';
import {getAllSavedSearches, deleteSavedSearch} from '../../../../../actions/jobs/jobs';
import {SavedSearchInfo} from '../../../features/jobs/pages/elements';
import { Pagination } from '../../../../common/elements';
import { Link } from 'react-router';
import { Loader } from '../../../../../components/common/elements/index';
import {DFP_SIZES} from "../../../../common/adverts/googleDFP/ReactDFPHelper";
import { AdSlot } from "react-dfp";

class SavedSearchPage extends Component {

    componentWillMount() {
        const { getAllSavedSearches, options, location,} = this.props;
        const personId = localStorage.getItem('person_id'), page = location.query.page;
             personId && getAllSavedSearches(personId, options, page ? page : 1);
    }

    deleteSavedSearch = (personId, searchId) => {

        const { deleteSavedSearch } = this.props;
        deleteSavedSearch( personId, searchId );
    };

    getNextSearches(pageId) {
        const { getAllSavedSearches, options } = this.props,
            person_id = localStorage.getItem('person_id');

        getAllSavedSearches( person_id, options, pageId );
		browserHistory.push(`/my-jobs-section/saved-searches?page=${pageId}#topoflist`);
    }

    render() {
        const {savedSearches, paging, location, isFetching} = this.props,
            pageLocation = location.query.page;

        if (isFetching ) {
            return <Loader/>;
        }

        const totalPages = paging && paging.total_pages,
            currentPage = Page.setCurrentPage(pageLocation, totalPages),
            pagination_details = Page.getCurrentPage(currentPage, totalPages),
            pageNumbers = Page.getPageNumbers(pagination_details);

        return (
            <div className="main__content">
                <h1 className="h1">Saved Searches</h1>

                {
                    (!savedSearches || savedSearches.length === 0) ?

                    <div className="saved__no-results">
                        <h4 className="h4">You don't currently have any saved searches.</h4>
                        <p className="p-tag">To run and save job search go to Jobs Board or click the button below:</p>
                        <Link className="btn btn-primary"
                              to={`/jobs`}>
                            <span className="label">Search for roles</span>
                        </Link>
                    </div>

                    :

                    <div className="table--jobs">
                        <div className="table__header hidden-xs hidden-sm">
                            <div className="row">
                                <div className="col-xs-12 col-md-3">
                                    <h5 className="h5 header">Search Name</h5>
                                </div>
                                <div className="col-xs-12 col-md-2">
                                    <h5 className="h5 header">Date Created</h5>
                                </div>
                                <div className="col-xs-12 col-md-2">
                                    <h5 className="h5 header">See More Info</h5>
                                </div>
                                <div className="col-xs-12 col-md-3">
                                    <h5 className="h5 header">Run This Search</h5>
                                </div>

                                <div className="col-xs-12 col-md-2">
                                    <h5 className="h5 header">Remove</h5>
                                </div>
                            </div>
                        </div>
                        <div className="table__body">
                            {
                                this.props.savedSearches && (
                                savedSearches.map((search, index) => {
                                    return (
                                        <div className="table__row" key={ index }>
                                            <SavedSearchInfo
                                                name={ search.name }
                                                createdAt={ search.created_at }
                                                keyword={search.keyword}
                                                index={ index }
                                                personId={ search.person_id}
                                                searchId={ search.id }
                                                deleteSavedSearch={ ( personId, searchId ) => this.deleteSavedSearch( personId, searchId ) }
                                            />
                                        </div>
                                    )
                                })
                                )
                            }
                        </div>
                    </div>
                }

                {
                    totalPages > 1 ? (
                        <Pagination
                            currentPage={currentPage}
                            pagination={pagination_details}
                            pageNumbers={pageNumbers}
                            totalPages={totalPages}
                            onPaginationClick={(currentPage) => this.getNextSearches(currentPage)}
                        />
                    ) : ''
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isFetching: state.jobs.isFetching,
        savedSearches: state.jobs.savedSearches,
        options: state.jobs.options,
        paging: state.jobs.pagination,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllSavedSearches: (personId, options, page) => dispatch(getAllSavedSearches(personId, options, page)),
        deleteSavedSearch: (personId, searchId, ) => dispatch(deleteSavedSearch(personId, searchId, )),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedSearchPage);



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/SavedSearchPage.js